<template>
    <div id="Company">
        <div class="without">
            <el-link class="withoutcloe" type="primary">公司认证 </el-link>
            <el-link class="withoutcloeBook" type="success">> 添加新公司认证</el-link>
        </div>
        <div class="without-xian">
        </div>
        <div class="basic">
            基础信息
        </div>
        <el-row>
            <el-col :span="12">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="公司名称">
                        <el-input size="medium" :readonly="!status" v-model="companyName" placeholder="请输入公司名称">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="固定电话">
                        <el-input size="medium" :readonly="!status" v-model="fixedTelnum" placeholder="请输入固定电话">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="电子邮箱">
                        <el-input size="medium" :readonly="!status" v-model="mailbox" placeholder="请输入电子邮箱"></el-input>
                    </el-form-item>
                    <el-form-item label="所在地">
                        <el-input v-if="!status" :readonly="!status" size="medium" v-model="address"
                            placeholder="请输入电子邮箱"></el-input>
                        <el-cascader v-if="status" size="medium" separator=" " :options="citys"
                            :props="{ expandTrigger: 'hover' }" @change="handleChange"></el-cascader>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="12"></el-col>
        </el-row>

        <div class="basic">
            企业认证
        </div>

        <!--  -->
        <el-row class="mkouasa" :gutter="24">
            <el-col :span="4.9">
                <div class="grid-content bg-purple">
                    <div class="moloua">
                        营业执照
                    </div>
                    <div class="mkouas">
                        <el-upload class="avatar-uploader" action="/" :show-file-list="false" :auto-upload="false"
                            :on-change="imgChange1">
                            <img v-if="img1" :src="img1" class="avatar">
                            <i v-if="!img1" class="el-icon-plus avatar-uploader-icon"></i>
                            <div v-if="!img1" class="avatar-uploader-txt">点击上传</div>
                        </el-upload>
                    </div>
                </div>
            </el-col>
            <el-col :span="4.9">
                <div class="grid-content bg-purple">
                    <div class="moloua">
                        危险品经营许可证
                    </div>
                    <div class="mkouas">
                        <el-upload class="avatar-uploader" action="/" :show-file-list="false" :auto-upload="false"
                            :on-change="imgChange2">
                            <img v-if="img2" :src="img2" class="avatar">
                            <i v-if="!img2" class="el-icon-plus avatar-uploader-icon"></i>
                            <div v-if="!img2" class="avatar-uploader-txt">点击上传</div>
                        </el-upload>
                    </div>
                </div>
            </el-col>
            <el-col :span="4.9">
                <div class="grid-content bg-purple">
                    <div class="moloua">
                        委托书（需下载<a download="moban.docx" :href="$store.state.imgUrl+'/uploadimg/moban.docx'"
                            class="blue">模板</a>按照要求上传）
                    </div>
                    <div class="mkouas">
                        <el-upload class="avatar-uploader" action="/" :show-file-list="false" :auto-upload="false"
                            :on-change="imgChange5">
                            <img v-if="img5" :src="img5" class="avatar">
                            <i v-if="!img5" class="el-icon-plus avatar-uploader-icon"></i>
                            <div v-if="!img5" class="avatar-uploader-txt">点击上传</div>
                        </el-upload>
                    </div>
                </div>
            </el-col>
            <el-col :span="4.9">
                <div class="grid-content bg-purple">
                    <div class="moloua">
                        被授权人身份证
                    </div>
                    <div class="mkouas">
                        <el-upload class="avatar-uploader" action="/" :show-file-list="false" :auto-upload="false"
                            :on-change="imgChange3">
                            <img v-if="img3" :src="img3" class="avatar">
                            <i v-if="!img3" class="el-icon-plus avatar-uploader-icon"></i>
                            <div v-if="!img3" class="avatar-uploader-txt">点击上传（正面）</div>
                        </el-upload>
                    </div>
                </div>
            </el-col>
            <el-col :span="4.9">
                <div class="grid-content bg-purple">
                    <div class="moloua">
                    </div>
                    <div class="mkouas">
                        <el-upload class="avatar-uploader" action="/" :show-file-list="false" :auto-upload="false"
                            :on-change="imgChange4">
                            <img v-if="img4" :src="img4" class="avatar">
                            <i v-if="!img4" class="el-icon-plus avatar-uploader-icon"></i>
                            <div v-if="!img4" class="avatar-uploader-txt">点击上传（反面）</div>
                        </el-upload>
                    </div>
                </div>
            </el-col>
        </el-row>
        <!--  -->
        <!-- <el-row>
            <el-col :span="12" style="margin-top: 30px;">
                <div style="margin-top: 15px;">
                    <el-form ref="form" :model="form" label-width="80px">
                        <el-form-item label="入市协议">
                            <el-input placeholder="请输入内容" v-model="input2">
                                <template slot="append">点击提交</template>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </el-col>
            <el-col :span="12"></el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <div style="margin-top: 15px;">
                    <el-form ref="form" :model="form" label-width="80px">
                        <el-form-item label="开票资料">
                            <el-input placeholder="请输入内容" v-model="input2">
                                <template slot="append">点击提交</template>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </el-col>
            <el-col :span="12"></el-col>
        </el-row> -->
        <el-row>
            <div style="margin-top: 15px;">
                <el-form ref="form" class="mioia" :model="form" label-width="80px">
                    <el-form-item label="公司简介">
                        <el-input :readonly="!status" placeholder="请输入公司简介" type="textarea" v-model="note"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </el-row>
        <el-form ref="form" class="mioia" :model="form" label-width="80px" v-if="status||state==0||state==3">
            <el-form-item>
                <el-button style="float: left;" label-position="left" type="primary" @click="onSubmit">提交认证</el-button>
            </el-form-item>
        </el-form>
        <div class="mkousssa" v-if="status">
            提交认证后，请等待1-3个工作日审核
        </div>
        <div class="mkousssa" v-if="state==1">
            正在审核
        </div>
    </div>
    </div>
</template>

<script>
    import citys from '../../assets/citys.json'
    export default {
        name: "Company",
        data() {
            return {
                status: false,
                form: {},

                state: '',

                companyName: '', //公司名称
                fixedTelnum: '', //固定电话
                mailbox: '', //电子邮箱
                address: '', //所在地
                note: '', //公司简介
                imgFiles: { //图片文件
                    files1: '',
                    files2: '',
                    files3: '',
                    files4: '',
                    files5: ''
                },

                img1: null,
                img2: null,
                img3: null,
                img4: null,
                img5: null,


                citys: citys,

                value: null,
            };
        },
        created() {
            if (this.$route.query.id) {
                this.getCompanyInfo();
            } else {
                this.status = true;
            }
        },
        methods: {
            imgChange1(file) {
                this.imgFiles.files1 = file.raw;
                this.img1 = URL.createObjectURL(file.raw);
            },
            imgChange2(file) {
                this.imgFiles.files2 = file.raw;
                this.img2 = URL.createObjectURL(file.raw);
            },
            imgChange3(file) {
                this.imgFiles.files3 = file.raw;
                this.img3 = URL.createObjectURL(file.raw);
            },
            imgChange4(file) {
                this.imgFiles.files4 = file.raw;
                this.img4 = URL.createObjectURL(file.raw);
            },
            imgChange5(file) {
                this.imgFiles.files5 = file.raw;
                this.img5 = URL.createObjectURL(file.raw);
            },
            handleChange(value) {
                this.address = value[0] + ' ' + value[1] + ' ' + value[2];
            },
            onSubmit() {
                var that = this;
                var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
                if (!that.companyName) {
                    this.$message({
                        message: '请输入公司名称',
                        type: 'warning'
                    });
                    return false;
                }
                if (!that.fixedTelnum) {
                    this.$message({
                        message: '请输入固定电话',
                        type: 'warning'
                    });
                    return false;
                }
                if (!that.mailbox) {
                    this.$message({
                        message: '请输入邮箱地址',
                        type: 'warning'
                    });
                    return false;
                }
                if (!reg.test(that.mailbox)) {
                    this.$message({
                        message: '邮箱格式不正确，请检查',
                        type: 'warning'
                    });
                    return false;
                }
                if (!that.address) {
                    this.$message({
                        message: '请选择公司所在地',
                        type: 'warning'
                    });
                    return false;
                }
                if (!that.imgFiles.files1) {
                    this.$message({
                        message: '营业执照文件不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                if (!that.imgFiles.files2) {
                    this.$message({
                        message: '危险品经营许可证文件不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                if (!that.imgFiles.files3) {
                    this.$message({
                        message: '身份正面文件不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                if (!that.imgFiles.files4) {
                    this.$message({
                        message: '身份证反面文件不能为空',
                        type: 'warning'
                    });
                    return false;
                }
                if (!that.imgFiles.files5) {
                    this.$message({
                        message: '委托书图片不能为空，请按照模板样式生成并上传',
                        type: 'warning'
                    });
                    return false;
                }
                if (!that.note) {
                    this.$message({
                        message: '公司简介不能为空',
                        type: 'warning'
                    });
                    return false;
                }

                var form = new FormData();

                form.append('files1', that.imgFiles.files1, that.imgFiles.files1.name);
                form.append('files2', that.imgFiles.files2, that.imgFiles.files2.name);
                form.append('files3', that.imgFiles.files3, that.imgFiles.files3.name);
                form.append('files4', that.imgFiles.files4, that.imgFiles.files4.name);
                form.append('files5', that.imgFiles.files5, that.imgFiles.files5.name);


                form.append('businessRegistrationNumberH5', that.$store.state.companyCode);
                form.append('companyName', that.companyName);
                form.append('fixedTelnum', that.fixedTelnum);
                form.append('mailbox', that.mailbox);
                form.append('address', that.address);
                form.append('note', that.note);
                form.append('userId', that.$store.state.userId);
                form.append('sysType', 1);

                that.request.post(that.$store.state.httpUrl + 'mobileInterf/makeCertificationH5', form, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    if (response.status == 200) {
                        this.goBack();
                    }
                })
            },
            getCompanyInfo() {
                let that = this;
                this.request.get(this.$store.state.httpUrl + "userDetails/findCompany", {
                    params: {
                        id: this.$route.query.id
                    }
                }).then(res => {
                    if (res.status == 200) {
                        if(!res.data){
                            that.status = true;
                            return;
                        }
                        that.isTrue = true;
                        that.companyName = res.data.companyName;
                        that.fixedTelnum = res.data.fixedTelnum;
                        that.mailbox = res.data.mailbox;
                        that.address = res.data.address;
                        that.note = res.data.note;
                        if (res.data.businessLicense.indexOf('http') != -1) {
                            that.img1 = res.data.businessLicense;
                            that.img2 = res.data.dangerousGoodsBusinessLicense;
                            that.img3 = res.data.idcardFront;
                            that.img4 = res.data.idcardOpposite;
                            that.img5 = res.data.licenseAgreement;
                        } else {
                            that.img1 = that.$store.state.imgUrl + res.data.businessLicense;
                            that.img2 = that.$store.state.imgUrl + res.data.dangerousGoodsBusinessLicense;
                            that.img3 = that.$store.state.imgUrl + res.data.idcardFront;
                            that.img4 = that.$store.state.imgUrl + res.data.idcardOpposite;
                            that.img5 = that.$store.state.imgUrl + res.data.licenseAgreement;
                        }

                        that.state = res.data.status;
                        if (res.data.status == 0 || res.data.status == 3) {
                            that.status = true;
                        }
                    }
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    /deep/ .el-input-group__append,
    .el-input-group__prepend {
        font-size: 14px;
        color: #D70606;
        background-color: #FFFFFF;
    }

    /deep/ .el-icon-location-information {
        color: #D70606;
    }

    /deep/ .el-cascader {
        width: 100%;
    }

    #Company {
        width: 920px;
        margin: 0 auto;
        height: 1041px;
        background: #FFFFFF;
        border-radius: 10px;
        padding: 28px;
        box-sizing: border-box;

        .without {
            text-align: left;
        }

        .withoutcloe {
            color: #999999;
        }

        .withoutcloeBook {
            color: #D70606;
        }

        .without-xian {
            margin-bottom: 26px;
            margin-top: 26px;
            height: 1px;
            background: #E6E6E6;
        }

        .basic {
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            text-align: left;
            margin-bottom: 20px;
        }

        .mkouasa {
            padding-left: 80px;
        }

        .mkouasa .grid-content {
            // padding-left: 25px;
        }

        /deep/ .el-textarea__inner {
            min-height: 157px !important;
            border-radius: 5px;
        }

        .mkousssa {
            text-align: left;
            margin-left: 75px;
            font-size: 16px;
            color: #999999;
        }

        .moloua {
            font-size: 14px;
            color: #999999;
            line-height: 48px;
            text-align: left;
            min-height: 50px;
        }

        .niasa {
            margin-top: 10px;
            font-size: 14px;
            color: #D70606;
        }

        .add {
            width: 35px;
            height: 35px;
            margin: 0 auto;
            color: #ccc;
            transition: color .25s;
            overflow: hidden;
            padding-bottom: 26px;
        }

        .add::before {
            content: '';
            position: absolute;
            left: calc(50% - 0);
            top: 35%;
            width: 36px;
            margin-left: -18px;
            margin-top: -5px;
            border-top: 6px solid;
        }

        .add::after {
            content: '';
            position: absolute;
            left: 50%;
            top: 33%;
            height: 36px;
            margin-left: -3px;
            margin-top: -17px;
            border-left: 6px solid;
        }
    }

    .avatar-uploader {
        width: 180px;
        height: 100px;
        background: #EBF1FF;
        border-radius: 10px;
        box-sizing: border-box;
        text-align: center;
    }

    .avatar-uploader .avatar {
        width: 180px;
        height: 100px;
        border-radius: 10px;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload--text {
        width: 100%;
        height: 100%;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 36px;
        color: #BAD0FF;
        margin-top: 20px;
    }

    .avatar-uploader-txt {
        font-size: 14px;
        color: #82ABFF;
        margin-top: 8px;
        width: 180px;
        padding-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/view/me/company.vue